import { ApiError } from './api';

/** Human-readable message for an error, with friendly text for known API codes. */
export function errorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    switch (e.code) {
      case 'FORBIDDEN':
        return 'Admin access required — your account is not on the ADMIN_EMAILS allowlist.';
      case 'NO_TEMPLATE':
        return 'No active "question_generation" prompt template. Create one under “Prompt templates” first.';
      case 'BUDGET_EXCEEDED':
        return 'Daily LLM budget reached — try again later.';
      case 'GENERATION_FAILED':
        return 'The model did not return valid questions. Try again or adjust the prompt template.';
      case 'EMAIL_NOT_CONFIGURED':
        return 'Resend is not configured on the API (RESEND_API_KEY / RESEND_WEBHOOK_SECRET).';
      case 'TEMPLATE_NOT_PUBLISHED':
        return 'That Resend template is not published. Publish it in the Resend Dashboard first.';
      case 'IDEMPOTENCY_CONFLICT':
        return 'This Idempotency-Key was already used with a different payload. Click “New idempotency key” and retry.';
      case 'EMAIL_PROVIDER_ERROR':
        return e.message || 'Resend rejected the send request.';
      case 'INVALID_SIGNATURE':
        return 'Webhook signature invalid.';
      default:
        return e.message || e.code;
    }
  }
  return e instanceof Error ? e.message : String(e);
}
